/**
 * SalesChart Component Types
 */
export const PRICE_BANDS = [
    { label: '<$1M', min: 0, max: 1_000_000 },
    { label: '$1-2M', min: 1_000_000, max: 2_000_000 },
    { label: '$2-5M', min: 2_000_000, max: 5_000_000 },
    { label: '$5-10M', min: 5_000_000, max: 10_000_000 },
    { label: '>$10M', min: 10_000_000, max: null },
];
/**
 * Combined sales+listings count above which the chart defaults to the
 * 'year' grouped-bar view instead of the individual-point scatter plot.
 * Calibrated against live data (2026-10): the median neighborhood has ~33
 * sales in a 10-year window and is perfectly readable as a scatter; the
 * densest neighborhoods (large condo complexes) and nearly all
 * districts/regions run into the hundreds-to-thousands and read as "all one
 * color" without aggregation. 150 sits just above the ~90th-percentile
 * neighborhood (157), so only the handful of scopes that actually need it
 * default to the aggregated view.
 */
export const AUTO_TOTALS_THRESHOLD = 150;
/**
 * Below either threshold, avgDaysOnMarket is reported as null (N/A)
 * instead of a number computed from a thin, unrepresentative slice of the
 * filtered sales. Calibrated against live data (2026-10): DOM coverage
 * falls off a cliff beyond ~3 years back (MLS retention + our backfill
 * depth) - e.g. one real region had 24% DOM coverage at a 5-year window
 * and literally zero additional DOM-bearing sales between 5 and 10 years,
 * so the 10-year average was silently identical to the 5-year one despite
 * claiming to reflect twice the history. The ratio catches scopes where
 * coverage has collapsed; the absolute floor catches scopes too small for
 * 5 items to mean anything regardless of ratio.
 */
export const MIN_DOM_SAMPLE = 5;
export const MIN_DOM_COVERAGE = 0.15;
/**
 * Fixed hue order for the House/Condo/Other categorical mix - same three
 * keys everywhere this breakdown shows up (filter chips, stacked area
 * segments), never reassigned per-scope. 'other' is a deliberately
 * desaturated gray (not a 3rd "real" hue) since it's a catch-all, not a
 * category someone is looking for - same convention as the muted chip
 * styling it already had before the bars existed, and it isn't one of the
 * PropertyTypeFilterValue options (only visible as part of 'all'). No Land
 * color/label - see PropertyTypeFilterValue's comment for why there's no
 * Land option at all. The other two are colorblind-distinguishable
 * (Okabe-Ito-derived: blue/purple).
 */
export const PROPERTY_TYPE_COLORS = {
    house: '#0072B2',
    condo: '#CC79A7',
    other: '#9CA3AF',
};
export const PROPERTY_TYPE_LABELS = {
    house: 'House',
    condo: 'Condo',
    other: 'Other/Unclassified',
};
/**
 * Chart colors
 */
export const CHART_COLORS = {
    sold: '#22c55e', // Green
    forSale: '#3b82f6', // Blue
    pending: '#eab308', // Yellow
    negotiationBelow: '#f97316', // Orange (sold below list)
    negotiationAbove: '#22c55e', // Green (sold above list)
    trendLine: '#93c5fd', // Light blue
    gridLines: '#e5e7eb', // Gray
};
/**
 * Time period configuration
 */
export const TIME_PERIODS = {
    '6m': { label: '6 Months', months: 6 },
    '1y': { label: '1 Year', months: 12 },
    '5y': { label: '5 Years', months: 60 },
    '10y': { label: '10 Years', months: 120 },
};
//# sourceMappingURL=types.js.map